import type { ReactElement, ReactNode } from 'react';
import { Icon } from '../Icon/Icon';
import styles from './Alert.module.scss';

export type AlertTone = 'info' | 'warning' | 'danger' | 'success';

export interface AlertProps {
  tone?: AlertTone;
  title?: ReactNode;
  children?: ReactNode;
}

const ICON = { info: 'info', success: 'check', warning: 'warning', danger: 'warning' } as const;

/** Сообщение на странице: ошибка (role=alert), предупреждение, успех, справка. */
export function Alert({ tone = 'info', title, children }: AlertProps): ReactElement {
  return (
    <div className={`${styles.alert} ${styles[tone]}`} role={tone === 'danger' ? 'alert' : 'status'}>
      <span className={styles.icon}>
        <Icon name={ICON[tone]} />
      </span>
      <div className={styles.body}>
        {title ? <strong>{title}</strong> : null}
        {children}
      </div>
    </div>
  );
}
